import React, { useEffect } from "react";
import { Switch, Route, Redirect, useHistory, useLocation } from "react-router-dom";
import Layout from "../components/Layout";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Header from "../components/Header";
import LiveToggle from "./LiveToggle";
import Title from "../components/Title";
import ChunkUploader from "../components/ChunkUploader";
import MyLists from "../components/MyLists";
import Account from "../components/Account";
import { useSession } from "./Session";
import { Divider, Typography } from "antd";
import ListPrint from "../components/ListPrint";
import Permissions from "../components/Permissions";
import ProcessFile from "../components/ProcessFile";

export default function SiteRouter(props) {

    const { sitesettings = {} } = props;
    const [session, setSession] = useSession();
    const loc = useLocation();


    useEffect(() => {

        if (!loc.pathname.includes("/browse")) {
            window.scrollTo(0, 0);
        }

    }, [loc.pathname])


    
    


    const subroutes = sitesettings.site_navigation.map((item) => {
        return item.submenu.filter(item => item.path && item.type !== "linked").map(item => {


            
            switch (item.type) {
            // Browse needs to handle it's path exactly and search with params
            case "browse": return (
                <Route key={"browse_exact"} path={item.path} children={<Layout page={item} />} />
            )

            case "catalogue": return (
                <Route key={"catalogues"} path={item.path} children={<Layout page={item} />} />
            )

            case "business-directory": return (
                <Route key={"business-directory"} path={item.path} children={<div><Layout page={item} /></div>} />
            )

            default: return <Route exact key={item.menu_id} path={item.path} children={<Layout page={item} />} />;

        }
        
            return (
                <Route exact key={item.menu_id} path={item.path} children={<Layout page={item} />} />
            )
        })
    });


    const hidden_routes = sitesettings.extra_navigation.map((item) => {
       
        return( <Route exact key={item.menu_id} path={item.path} children={<Layout page={item} />} />)
    });
    

    const routes = sitesettings.site_navigation.filter(item => item.path && item.type !== "linked").map((item) => {


        if (item.label === "Business Directory") {
            return (<Route key={"business-directory"} path={item.path} children={<Layout page={item} />} />)
        }

        switch (item.type) {
            // Browse needs to handle it's path exactly and search with params
            case "browse": return (
                <Route key={"browse_exact"} path={item.path} children={<Layout page={item} />} />
            )

            case "catalogue": return (
                <Route key={"catalogues"} path={item.path} children={<Layout page={item} />} />
            )

            case "business-directory": return (
                <Route key={"business-directory"} path={item.path} children={<div><Layout page={item} /></div>} />
            )

            default: return <Route exact key={item.menu_id} path={item.path} children={<Layout page={item} />} />;

        }
    });



    return (
        <div className="bm-background-color">
            <div id="bm-notification"></div>
            <Header key="header" />
            <Nav key="nav" />
            <main id="main-content" tabIndex="-1" role="main" style={{ minHeight: "calc(100vh - 374px)" }}>
                <Switch>
                    <Redirect from="/r/eigr/:item_id" to="/item/:item_id" />

                     <Redirect from="/tbm" to="/" />

                    <Route path="/print/list/:list_id" children={<><ListPrint /></>} />
                    <Route path="/item/:item_id" children={<><div className="container"><Title view="full" /></div></>} />
                    <Route path="/build/:process_id" children={<><ProcessFile /></>} />
                    <Route exact path="/su" children={<div >
                        <div className="container">
                            <Typography.Title level={4} style={{ "fontWeight": "normal" }}>Simple file upload</Typography.Title>
                            <Divider style={{ margin: "15px 0px" }} dashed />
                            <div className="shim" />
                            <Typography.Paragraph>
                                In order to cut down time spent transferring large files or multiple files, please archive your files using Winzip, Winrar, 7-Zip, or others.
                                <div className="shim" />
                                This upload service allows 1GB files and allows for the continuation of a failed upload.
                            </Typography.Paragraph>
                            <div className="shim" />
                            <div style={{ "padding": "0px", "margin": "0 auto" }}>
                                <ChunkUploader label="Click or drag file to upload." />
                                <br /><br />
                                <ChunkUploader is_button="false" />
                            </div>
                        </div>

                    </div>} />
                    {session.logged_in && <Route path="/my-lists" children={<><MyLists /></>} />}
                    <Route path="/account/:view" children={<><Account /></>} />
                    
                    {subroutes}
                    {routes}
                    {hidden_routes}
                </Switch>
            </main>
            <Footer store_info={sitesettings.store_info} />
            <LiveToggle />
        </div>
    )
}